import BBCodeText from './gameobjects/text/bbcodetext/BBCodeText.js'
export default BBCodeText;